var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Entity, EntityBuilder, Type } from '@decahedron/entity';
import { User } from 'packages/users/User';
import { EventType } from './EventType';
import { Email } from 'packages/email/entities/Email';
import { Tag } from 'packages/company/entities/Tag';
import Application from 'packages/jobs/entities/Application';
import { ChatMessage } from 'packages/chat/ChatMessage';
import { Response } from 'packages/form/entities/legacy/Response';
var domainTypes = {
    'email': Email,
    'application': Application,
    'talent-tag': Tag,
    'form-response': Response,
    'chat-message': ChatMessage,
};
var TalentTimelineItem = /** @class */ (function (_super) {
    __extends(TalentTimelineItem, _super);
    function TalentTimelineItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.id = null;
        _this.createdAt = '';
        _this.eventType = new EventType();
        _this.actor = null;
        _this.target = null;
        _this.stateTo = null;
        _this.stateFrom = null;
        return _this;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    TalentTimelineItem.prototype.fromJson = function (jsonData) {
        _super.prototype.fromJson.call(this, jsonData);
        var buildType = domainTypes[this.eventType.domain];
        this.target = (buildType && jsonData.target)
            ? EntityBuilder.buildOne(buildType, jsonData.target)
            : jsonData.target;
        this.stateTo = (buildType && jsonData.state_to)
            ? EntityBuilder.buildOne(buildType, jsonData.state_to)
            : jsonData.state_to;
        this.stateFrom = (buildType && jsonData.state_from)
            ? EntityBuilder.buildOne(buildType, jsonData.state_from)
            : jsonData.state_from;
        return this;
    };
    var _a, _b;
    __decorate([
        Type(EventType),
        __metadata("design:type", typeof (_a = typeof EventType !== "undefined" && EventType) === "function" ? _a : Object)
    ], TalentTimelineItem.prototype, "eventType", void 0);
    __decorate([
        Type(User),
        __metadata("design:type", typeof (_b = typeof User !== "undefined" && User) === "function" ? _b : Object)
    ], TalentTimelineItem.prototype, "actor", void 0);
    return TalentTimelineItem;
}(Entity));
export { TalentTimelineItem };
